import PropTypes from 'prop-types';
import React from 'react';
// -*- mode: jsx;-*-
import { handleCloseClick as innerHandleCloseClick } from '../common/shareBarUtils.js';
import { Svg } from '../common/Svg.js';
import { EmailLink } from '../common/EmailLink.js';
import { FacebookLink } from '../common/FacebookLink.js';
import { SmsLink } from '../common/SmsLink.js';
import { TwitterLink } from '../common/TwitterLink.js';


/* global redirectToTwitterWithShortenedUrl */ // from sharebarHelperFunctions.js

export let TeacherShareBar = function (props) {
    const handleCloseClick = (event) => {
        innerHandleCloseClick(event, props.root);
    }

    return (
        <div className="container">
            <a href="" className="mobile delete" onClick={handleCloseClick} aria-label="close">
                <Svg icon="delete" attributes={{ role: 'presentation' }} additionalClasses="is-button"/>
            </a>
            <h2 className="teacher-share-headline">Give your friends and family a glimpse inside your&nbsp;classroom:</h2>
            <ul className="teacher-share-buttons share-wrapper">
                <li>
                    <EmailLink
                        className="button-secondary button-email"
                        secure={false}
                        tafURL={props.tafURL}
                        pageName={props.pageName}
                        getTafEmail={props.getTafEmail}
                        onEmailClick={() => {}}
                    >Share via email</EmailLink>
                </li>
                <li>
                    <FacebookLink
                        className="button-secondary button-facebook"
                        urlToShare={props.teacherProfileURL}
                        getTrackingLink={props.getTrackingLink}
                        facebookAppId={props.facebookAppId}
                        onFacebookClick={() => {}}
                    >Share on Facebook</FacebookLink>
                </li>
                {/* hidden as of nov 22 2022 for prod test on share options
                <li>
                    <TwitterLink
                        className="button-secondary button-twitter"
                        urlToShare={props.teacherProfileURL}
                        text={props.getTeacherProfileTwitterText({ isUserTheTeacher: true })}
                        getTrackingLink={props.getTrackingLink}
                        onTwitterClick={redirectToTwitterWithShortenedUrl //redirectToTwitterWithShortenedUrl is globally-defined
                    >Share on Twitter</TwitterLink>
                </li>
                */}

                {/* Hidden when non-mobile */}
                <li>
                    <SmsLink
                        className="button-secondary button-sms"
                        text={props.getTeacherProfileTwitterText({ isUserTheTeacher: true, stripHandle: true })}
                        urlToShare={props.teacherProfileURL}
                        onSmsClick={() => {}}
                    >Share via text</SmsLink>
                </li>
            </ul>
        </div>
    );
};

TeacherShareBar.propTypes = {
    teacherProfileURL: PropTypes.string.isRequired,
    pageName: PropTypes.string.isRequired,
    tafURL: PropTypes.string.isRequired,
    getTafEmail: PropTypes.func.isRequired,
    getTrackingLink: PropTypes.func.isRequired,
    facebookAppId: PropTypes.string.isRequired,
    getTeacherProfileTwitterText: PropTypes.func.isRequired,
    root: PropTypes.any.isRequired, // the parent DOM node in which the bar is rendered
};

TeacherShareBar = React.memo(TeacherShareBar);
